// Calendar-day helpers in the browser's timezone. The dashboard counts days in
// the viewer's timezone (DASHBOARD_API.md Overview), so dates here must never
// go through UTC — `toISOString().slice(0, 10)` returns the previous day for
// anyone east of UTC before their offset has passed.

export const browserTimeZone = () => Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';

const pad = (n) => String(n).padStart(2, '0');

// Date → local "YYYY-MM-DD".
export const toYmd = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

// "YYYY-MM-DD" → local midnight of that day (no UTC parsing).
export const fromYmd = (ymd) => {
  const [y, m, d] = String(ymd).split('-').map(Number);
  return new Date(y, m - 1, d);
};

export const todayYmd = () => toYmd(new Date());

// `days` before (negative) or after the given "YYYY-MM-DD".
export const addDaysYmd = (ymd, days) => {
  const d = fromYmd(ymd);
  d.setDate(d.getDate() + days);
  return toYmd(d);
};

// Inclusive number of calendar days from `from` to `to`.
export const daysBetweenInclusive = (from, to) => Math.round((fromYmd(to) - fromYmd(from)) / 86400000) + 1;

// [start, end) of a local calendar day as UTC ISO strings — handles DST because
// the next day is built from calendar fields, not by adding 24h.
export const dayBoundsIso = (ymd) => {
  const start = fromYmd(ymd);
  const end = new Date(start);
  end.setDate(end.getDate() + 1);
  return [start.toISOString(), end.toISOString()];
};
